import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  openModal,
  closeModal
} from 'actions/modals'
import {
  clearError
} from 'actions/visits'
import { VISIT_UNCONNECTED_MODAL, SEND_MESSAGE_MODAL } from 'constants/modals'
import UnconnectedVisitModal from 'components/UnconnectedVisitModal'
import SendMessageModal from 'components/SendMessageModal'
import {
  getMessageCost,
  sendTextMessage
} from 'actions/api/messaging'
import {
  declineVisit,
  cancelVisit
} from 'actions/api/visits'

class UnconnectedVisitModalContainer extends Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.visitUnconnected && this.props.visitUnconnected) {
      this.props.openModal(VISIT_UNCONNECTED_MODAL)
    }
  }

  render() {
    const {
      modalOpened,
      sendMessageModalOpened,
      openModal,
      closeModal,
      redirectURL,
      reason,
      errorMessage,
      clearError,
      messagingEnabled,
      getTextMessageCost,
      sendTextMessage,
      balance,
      cost,
      freeMessages,
      costError,
      sendError,
      loading,
      isInitiator,
      declineVisit,
      cancelVisit
    } = this.props

    return (
      <>
        <UnconnectedVisitModal
          show={modalOpened}
          reason={reason}
          errorMessage={errorMessage}
          openModal={openModal}
          closeModal={closeModal}
          clearError={clearError}
          redirectURL={redirectURL}
          messagingEnabled={messagingEnabled}
          getTextMessageCost={getTextMessageCost}
          costError={costError}
          loading={loading}
          isInitiator={isInitiator}
          declineVisit={declineVisit}
          cancelVisit={cancelVisit}
        />
        <SendMessageModal
          show={sendMessageModalOpened}
          closeModal={closeModal}
          redirectURL={redirectURL}
          sendTextMessage={sendTextMessage}
          rate={cost}
          balance={balance}
          freeMessages={freeMessages}
          maxLength={500}
          serverError={sendError}
          loading={loading}
        />
      </>
    )
  }
}

function mapStateToProps (state) {
  return {
    modalOpened: state.modal.currentModal === VISIT_UNCONNECTED_MODAL,
    sendMessageModalOpened: state.modal.currentModal === SEND_MESSAGE_MODAL,
    visitUnconnected: state.visit.visitUnconnected,
    reason: state.visit.unconnectedReason,
    errorMessage: state.visit.unconnectedErrorCode,
    redirectURL: state.visit.redirectURL,
    messagingEnabled: state.visit.afterCallMessagingEnabled,
    appointmentId: state.visit.appointmentId,
    balance: state.textMessage.balance,
    cost: state.textMessage.cost,
    freeMessages: state.textMessage.freeMessages,
    costError: state.textMessage.costError,
    sendError: state.textMessage.sendError,
    loading: state.textMessage.loading
  }
}

function mapDispatchToProps (dispatch) {
  return {
    openModal: (modal) => dispatch(openModal(modal)),
    closeModal: (modal) => dispatch(closeModal(modal)),
    clearError: () => dispatch(clearError()),
    getTextMessageCost: (appointmentId, messageType, onSuccess) => dispatch(getMessageCost(appointmentId, messageType, onSuccess)),
    sendTextMessage: (appointmentId, text, onSuccess) => dispatch(sendTextMessage(appointmentId, text, onSuccess)),
    declineVisit: (onSuccess) => dispatch(declineVisit(onSuccess)),
    cancelVisit: (appointmentId, onSuccess) => dispatch(cancelVisit(appointmentId, onSuccess))
  }
}

function mergeProps (stateProps, dispatchProps, ownProps) {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    getTextMessageCost: (onSuccess) => { dispatchProps.getTextMessageCost(stateProps.appointmentId, 'text', onSuccess) },
    sendTextMessage: (text, onSuccess) => { dispatchProps.sendTextMessage(stateProps.appointmentId, text, onSuccess) },
    cancelVisit: (onSuccess) => { dispatchProps.cancelVisit(stateProps.appointmentId, onSuccess) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UnconnectedVisitModalContainer)
